import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

/** 状态定义 */

const store = new Vuex.Store({
  state: {
    base64: [],
    object: {}
  },
  getters: {},
  mutations: {
    setBase64 (state, value) {
      state.base64 = value
    },
    setObject (state, value) {
      state.object = value
    }
  },
  actions: {}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js